import api from './axiosConfig';

export const loginApi = (email, password) => {
  return api.post('/v1/auth/login', { email, password });
};

export const registerApi = (userData) => {
  return api.post('/v1/auth/register', userData);
};

export const logoutApi = () => {
  // Option: call server to invalidate token, then local storage
  return Promise.resolve();
};

export const refreshTokenApi = () => {
  return api.post('/v1/auth/refresh');
};

export const updateProfileApi = (profileData) => {
  return api.put('/v1/auth/profile', profileData);
};
